"use strict";

var _slicedToArray = require("/home/circleci/repo/node_modules/gatsby/node_modules/@babel/runtime/helpers/slicedToArray");

var _objectWithoutProperties = require("/home/circleci/repo/node_modules/gatsby/node_modules/@babel/runtime/helpers/objectWithoutProperties");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _emotionTheming = require("emotion-theming");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _NavigationList = require("./NavigationList.style");

var NavigationListItem = function NavigationListItem(_ref) {
  var link = _ref.link,
      active = _ref.active,
      isNavOpen = _ref.isNavOpen,
      closeNav = _ref.closeNav,
      isLargeNav = _ref.isLargeNav,
      place = _ref.place,
      variation = _ref.variation,
      rest = _objectWithoutProperties(_ref, ["link", "active", "isNavOpen", "closeNav", "isLargeNav", "place", "variation"]);

  var _ref2 = (0, _emotionTheming.useTheme)(),
      space = _ref2.space;

  var isMobileNav = !isLargeNav;
  var hasNavItems = link.navItems && link.navItems.length > 0;

  var _ref3 = (0, _react.useState)(false),
      _ref4 = _slicedToArray(_ref3, 2),
      isExpanded = _ref4[0],
      setIsExpanded = _ref4[1];

  var handleClick = function handleClick() {
    if (isMobileNav && isExpanded) {
      setIsExpanded(false);
    }

    if (isMobileNav && !isExpanded) {
      setIsExpanded(true);
    }
  };

  (0, _react.useEffect)(function () {
    if (isNavOpen === false) {
      setIsExpanded(false);
    }
  }, [isNavOpen]);

  var navOnClick = function navOnClick(item) {
    closeNav(); // eslint-disable-next-line no-unused-expressions

    item && typeof item.onClick === 'function' && item.onClick();
  };

  return /*#__PURE__*/_react.default.createElement(_NavigationList.NavItem, Object.assign({
    active: active === link.url,
    place: place,
    isExpanded: isLargeNav || isExpanded,
    variation: variation
  }, rest), hasNavItems ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_NavigationList.NavItemContainer, {
    onClick: function onClick() {
      return handleClick();
    },
    place: place
  }, /*#__PURE__*/_react.default.createElement(_NavigationList.NavItemText, {
    as: "h4",
    place: place,
    isExpanded: isLargeNav || isExpanded,
    variation: variation
  }, link.label), isMobileNav && hasNavItems && /*#__PURE__*/_react.default.createElement(_NavigationList.NavItemIcon, {
    name: "ChevronDown",
    size: space.base,
    transform: isExpanded ? 'rotate(180deg)' : 'rotate(0deg)',
    place: place,
    variation: variation
  })), /*#__PURE__*/_react.default.createElement(_NavigationList.ExpandedLinksWrapper, {
    isExpanded: isLargeNav || isExpanded,
    place: place
  }, /*#__PURE__*/_react.default.createElement(_NavigationList.SubNavItemContainerHome, {
    place: place,
    link: link,
    variation: variation
  }, link.description && /*#__PURE__*/_react.default.createElement(_NavigationList.NavItemDescription, null, link.description), link.url && /*#__PURE__*/_react.default.createElement(_NavigationList.SubNavLink, {
    to: link.url,
    onClick: function onClick() {
      return navOnClick(link);
    },
    place: place,
    variation: variation
  }, /*#__PURE__*/_react.default.createElement(_NavigationList.SubNavItemTextHome, {
    active: active === link.url,
    as: "span",
    place: place,
    isExpanded: isLargeNav || isExpanded,
    variation: variation
  }, link.label, " Home"))), link.navItems.map(function (item) {
    return /*#__PURE__*/_react.default.createElement(_NavigationList.SubNavItemContainer // eslint-disable-next-line react/no-array-index-key
    , {
      key: item.label,
      place: place
    }, /*#__PURE__*/_react.default.createElement(_NavigationList.SubNavLink, {
      to: item.url,
      onClick: function onClick() {
        return navOnClick(item);
      },
      place: place
    }, /*#__PURE__*/_react.default.createElement(_NavigationList.SubNavItemText, {
      active: active === item.url,
      as: "span",
      place: place,
      variation: variation,
      isExpanded: isLargeNav || isExpanded
    }, item.label)));
  }))) : /*#__PURE__*/_react.default.createElement(_NavigationList.NavItemContainer, {
    variation: variation,
    place: place
  }, /*#__PURE__*/_react.default.createElement(_NavigationList.MainNavLink, {
    to: link.url,
    onClick: function onClick() {
      return navOnClick(link);
    },
    place: place
  }, /*#__PURE__*/_react.default.createElement(_NavigationList.SubNavItemSolo, {
    active: active === link.url,
    as: "h4",
    place: place
  }, link.label)), link.description && /*#__PURE__*/_react.default.createElement(_NavigationList.NavItemSoloDescription, null, link.description)));
};

NavigationListItem.propTypes = {
  link: _propTypes.default.shape(Object).isRequired,
  active: _propTypes.default.string,
  isNavOpen: _propTypes.default.bool,
  closeNav: _propTypes.default.func,
  isLargeNav: _propTypes.default.bool.isRequired,
  place: _propTypes.default.oneOf(['header', 'footer', 'legacyHeader']),
  variation: _propTypes.default.oneOf(['mega', 'primary'])
};
NavigationListItem.defaultProps = {
  active: '',
  isNavOpen: false,
  closeNav: function closeNav() {},
  place: 'footer',
  variation: 'mega'
};
var _default = NavigationListItem;
exports.default = _default;